import { useEffect } from "react";
import { toggleMapLabelVisibility } from "@macrostrat/mapbox-utils";
export function useMapConditionalStyle(mapRef, state, operator) {
  /** Apply conditional style logic depending on a state value or object.
   * The operator function can operate on the Map and the state, and is applied on state changes
   * and on style load events. */
  useEffect(function () {
    var map = mapRef.current;
    if (map == null) return;

    if (map.isStyleLoaded()) {
      operator(map, state);
    }

    map.on("style.load", function () {
      return operator(map, state);
    });
  }, [mapRef.current, state]);
}

var _toggleMapLabels = function _toggleMapLabels(map, state) {
  return toggleMapLabelVisibility(map, state.mapShowLabels, state.omitLayers);
};

export function useMapLabelVisibility(mapRef, mapShowLabels) {
  var omitLayers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  useMapConditionalStyle(mapRef, {
    mapShowLabels: mapShowLabels,
    omitLayers: omitLayers
  }, _toggleMapLabels);
}